import { IMAGES } from "@/lib/images";
import Reveal from "@/components/Reveal";

export default function Intro() {
  return (
    <section data-testid="intro" className="bg-[#FAF8F5] text-[#1C1917] py-24 lg:py-36 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7 relative">
          <Reveal>
            <span className="text-[#7A8B7B] text-[11px] tracking-[0.35em] uppercase font-semibold">The Philosophy</span>
            <h2 className="font-serif text-5xl sm:text-7xl lg:text-8xl font-medium leading-[0.95] tracking-tight mt-6">
              Not just lashes.<br /><span className="italic text-[#C5B382]">A custom look.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-9 text-lg sm:text-xl text-[#1C1917]/70 leading-relaxed max-w-xl">
              “Every set is designed around your natural lashes, eye shape and the look you
              want to create.”
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-5 relative">
          <Reveal delay={0.1}>
            <div className="relative aspect-[3/4] max-w-sm ml-auto">
              <img src={IMAGES.introLash} alt="Lash detail" className="w-full h-full object-cover rounded-[2rem] shadow-soft" />
              <span
                className="hidden lg:block absolute -left-14 top-1/2 -translate-y-1/2 text-[#1C1917]/10 font-serif text-[8rem] font-medium leading-none tracking-tight"
                style={{ writingMode: "vertical-rl" }}
              >
                custom
              </span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
